module.exports = __webpack_public_path__ + "img/mutlog.6fb04b2c.png";